import { ImportWithTemplateModal } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { selectCompany } from "../../../homeSlice";
import { uploadDriverPlanningsFileThunk } from "../driverPlanningsSlice";
import "../../../../../i18n/i18n";
import {
  getDriverPlanningHeaderErrors,
  getDriverPlanningLineErrors,
} from "../driverPlanningFormat/driverPlanningsErrors";
import { driverPlanningHeaderColumns } from "../driverPlanningFormat/driverPlanningsHeaders";

const DRIVER_PLANNING_TEMPLATE_FILE_NAME = "fichier_d_import_de_plannings.xlsx";

export const ImportDriverPlanningsModal = (props: {
  visible: boolean;
  onCloseModal: () => void;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);

  const templateColumns = driverPlanningHeaderColumns.map(
    (column) => column.acceptedHeaders[0],
  );

  return (
    <ImportWithTemplateModal
      visible={props.visible}
      onCloseModal={props.onCloseModal}
      title={t("trips.importPlanning.title")}
      returnButtonText={t("trips.importPlanning.button.return")}
      template={{
        fileName: DRIVER_PLANNING_TEMPLATE_FILE_NAME,
        columns: templateColumns,
        sheetName: "Plannings",
      }}
      validateRows={(rows) => [
        ...getDriverPlanningHeaderErrors(rows[0] ?? []),
        ...getDriverPlanningLineErrors(rows),
      ]}
      onSubmit={(file) => {
        if (!company) return;
        void dispatch(
          uploadDriverPlanningsFileThunk({
            file,
            companyUuid: company.uuid,
          }),
        );
      }}
      errorTypeToLabel={(errorType) =>
        t(`trips.importPlanning.errorType.${errorType}`)
      }
    />

  );
};
